/* eslint-disable */
import { useEffect, useRef, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import html2pdf from "html2pdf.js";
import JsBarcode from "jsbarcode";
import _ from "lodash/fp";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { getAdvtDetailsForAdmin } from "../../application_management/actions/advertisementAction";
import PrintApplicationDetails from "../../application_management/components/PrintApplicationDetails";
import PrintProfileDetails from "../../application_management/components/PrintProfileDetails";
import {
  candidateProfileUnlock,
  getActiveAdvertisementList,
  getApplicationDetailsAPI,
  getMergedProfileInfoDisplay,
  resetCandidateList,
  searchCandidateListForCheckEligibility,
  setShowActiveCandidate,
  printPaymentReceipt
} from "../../candidatedatamanagement/actions/candidateDataManagementAction";
import ActiveCandidateDetailsTab from "../../candidatedatamanagement/components/ActiveCandidateDetailsTab";
import label from "../../candidatedatamanagement/labels/candidatedatamanagement_en.json";
import challanLabels from "../../challanmanagement/Labels/challan_en.json";
import { getEditProfileWithLock } from "../../common/actions/commonActions";
import {
  emailRegex,
  mobileRegex,
  numberValidation,
  alphanumeric 
} from "../../common/constants/regex";
import commonLabels, {
  default as common,
} from "../../common/labels/common_en.json";
import { getYearList } from "../../documentsverification/actions/documentVerificationAction";
import docLabels from "../../documentsverification/labels/documentlabel.json";
import myaccountlable from "../../my_account/labels/my_account_en.json";
import "../styles/candidate_management.css";
import Select from "react-select";

const CandidateDataManagement = (props) => {
  const { register, watch, errors, reset, formState } = useForm({
    mode: "onChange",
  });

  const printRef = useRef();
  const [isPrinting, setIsPrinting] = useState(false);
  const dispatch = useDispatch();
  const [startYear, setStartYear] = useState(new Date().getFullYear());

  let [currentApplicationData, setCurrentApplicationData] = useState();
  const { yearList } = useSelector(
    (state) => state.documentVerificationReducer,
    shallowEqual
  );

  const [isAdminSide, setIsAdminSide] = useState(true);
  const {
    activeAdvertisementList,
    candidateList,
    advertisementId,
    showActiveTabCandidateDetails,
  } = useSelector(
    (state) => state.candidateDataManagementReducer,
    shallowEqual
  );
  const { applicationDetails } = useSelector(
    (state) => state.candidateDataManagementReducer,
    shallowEqual
  );
  const [seachType, setSearchType] = useState("");
  const [emailId, setEmailId] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [aadhaarNumber, setAadhaarNumber] = useState("");
  const [applicationNo, setApplicationNo] = useState("");
  const [otrNumber, setOtrNumber] = useState("");

  const [candidateProfileId, setCandidateProfileId] = useState("");
  //   let emailId = watch("emailId");
  //   let mobileNumber = watch("mobileNumber")
  //   let aadhaarNumber = watch("aadhaarNumber")
  //   let applicationNo = watch("applicationNo")
  const [advtIdForSearch, setAdvtForSearch] = useState("");
  const [printProfile, setPrintProfile] = useState(false);
  useEffect(() => {
    dispatch(getYearList());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    dispatch(getEditProfileWithLock());
  }, []);
  useEffect(() => {
    setAdvtForSearch("");
    dispatch(resetCandidateList());
    // eslint-disable-next-line
  }, [props.isTab]);
  useEffect(() => {
    if (yearList && yearList.length > 0) {
      let year = yearList[0];
      setStartYear(year);
      dispatch(getActiveAdvertisementList(year));
    }
    // eslint-disable-next-line
  }, [yearList]);

  const handleDropdownSeachType = (e) => {
    setSearchType(e.target.value);
    dispatch(resetCandidateList());
    // setAdvtForSearch("");
  };

  const handleDropdownSeachAdvt = (e) => {
    setAdvtForSearch(e.target.value);
    dispatch(resetCandidateList());
  };

  const viewCandidateDetails = (ele) => {
    setCandidateProfileId(
      ele && ele.personalInfoList && ele.personalInfoList.profileId
    );
    if (props.isTab == "3") {
      let profileId =
        ele && ele.personalInfoList && ele.personalInfoList.profileId;
      let jwtResponse = ele && ele.jwtResponse;
      dispatch(getMergedProfileInfoDisplay(profileId, jwtResponse, ""));
      let appId = ele && ele.applicationId;
      dispatch(getApplicationDetailsAPI(appId));
      setPrintProfile(true);
    } else if (props.isTab == "4") {
      let profileId =
        ele && ele.personalInfoList && ele.personalInfoList.profileId;
      let jwtResponse = ele && ele.jwtResponse;
      dispatch(getMergedProfileInfoDisplay(profileId, jwtResponse, ""));
      setPrintProfile(true);
    } else {
      dispatch(setShowActiveCandidate(true, advtIdForSearch, ele));
      dispatch(getAdvtDetailsForAdmin(advtIdForSearch));
    }
  };
  useEffect(() => {
    if (
      applicationDetails &&
      applicationDetails.application &&
      applicationDetails.application.length > 0
    ) {
      setPrintProfile(true);
    }
    // eslint-disable-next-line
  }, [applicationDetails]);

  const searchAction = () => {
    let requestBody = {};
    if (props.isTab == 1) {
      requestBody.eligibilityType = "check_Eligibility";
    } else if (props.isTab == 2) {
      requestBody.eligibilityType = "re_Check_Eligibility";
    } else if (props.isTab == 3) {
      requestBody.eligibilityType = "application_download";
    } else if (props.isTab == 4) {
      requestBody.eligibilityType = "profile_download";
    }
    if (seachType == "email") {
      requestBody.value = emailId;
    }
    if (seachType == "mobile") {
      requestBody.value = mobileNumber;
    }
    if (seachType == "aadhaar") {
      requestBody.value = aadhaarNumber;
    }
    if (seachType == "applicationNo") {
      requestBody.value = applicationNo;
    }

    if (seachType == "otrNumber") {
      requestBody.value = otrNumber;
    }
    requestBody.type = seachType;
    requestBody.advertisementId = advtIdForSearch;
    dispatch(searchCandidateListForCheckEligibility(requestBody));
  };

  const handleValueParam = (name, val) => {
    if (name == "emailId") {
      setEmailId(val);
    }
    if (name == "mobileNumber") {
      setMobileNumber(val);
    }
    if (name == "aadhaarNumber") {
      setAadhaarNumber(val);
    }
    if (name == "applicationNo") {
      setApplicationNo(val);
    }
    if (name == "otrNumber") {
      setOtrNumber(val);
    }
  };

  const resetAction = (e) => {
    setSearchType("");
    setAdvtForSearch("");
    reset();
    activeAdvertisementList.length = 0;
    dispatch(resetCandidateList());
    setStartYear(new Date().getFullYear());
    if (yearList && yearList.length > 0) {
      let year = yearList[0];
      setStartYear(year);
      dispatch(getActiveAdvertisementList(year));
    }
  };

  const handleYearChange = (value) => {
    setStartYear(value);
    dispatch(getActiveAdvertisementList(value));
    setAdvtForSearch("");
    dispatch(resetCandidateList());
  };

  // const handlePrint = () => {
  //     const printContents = printRef.current.innerHTML;
  //     const originalContents = document.body.innerHTML;
  //     document.body.innerHTML = printContents;
  //     window.print();
  //     document.body.innerHTML = originalContents;
  // };

  // const handlePrint = () => {
  //     const printContents = printRef.current.innerHTML;
  //     const printContainer = document.createElement('div');
  //     printContainer.innerHTML = printContents;
  //     document.body.innerHTML = '';
  //     document.body.appendChild(printContainer);
  //     window.print();
  //     window.location.reload();
  // };



  const printApplication = async (applicationDetails) => {
    setIsPrinting(true);
    setTimeout(() => {
      // window.print();
      genPrintPdf(applicationDetails);

      setIsPrinting(false);
    }, 0);
  };
  const genPrintPdf = (applicationDetails) => {
    const htmlContent = document.createElement("div");
    htmlContent.innerHTML = printRef.current.innerHTML;
    const style = document.createElement("style");
    style.innerHTML = ` 
            thead, tbody {
                display: table-header-group !important;
                white-space: normal !important; 
            }
            `;
    htmlContent.appendChild(style);
    const options = {
      margin: [1.2, 0.4, 0.6, 0.4],
      image: { type: "jpeg", quality: 0.6 },
      html2canvas: { scale: 2, dpi: 300, letterRendering: true },
      pagebreak: { mode: "avoid-all" },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };
    const filename = "candidate_profile";
    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const headerImage = new Image();
        headerImage.src = "/logos/BPSC_HEADER.png";
        const barcodeCanvas = document.createElement("canvas");
        JsBarcode(barcodeCanvas, "123456789", {
          format: "CODE128",
          displayValue: false,
          width: 1.5,
          height: 20,
          background: "#FFFFFF",
          lineColor: "#000000",
        });
        const barcodeDataUrl = barcodeCanvas.toDataURL("image/svg+xml");
        headerImage.onload = () => {
          const sideMargin = 0.5;
          const topMargin = 0.2;
          const bottomMargin = 0.6;
          const imgWidth = pageWidth - 2 * sideMargin;
          const aspectRatio = headerImage.width / headerImage.height;
          let imgHeight = imgWidth / aspectRatio;

          if (imgHeight > pageHeight - (topMargin + bottomMargin)) {
            imgHeight = pageHeight - (topMargin + bottomMargin);
          }

          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);

            if (i === 1) {
              pdf.addImage(
                headerImage,
                "PNG",
                sideMargin,
                topMargin,
                imgWidth,
                imgHeight
              );
            }
            const textWidth =
              (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
              pdf.internal.scaleFactor;

            const textX = pageWidth - textWidth - 0.5;
            const textY = pdf.internal.pageSize.getHeight() - 0.3;

            const otrcodeWidth = 2.5;
            const otrcodeX = 0.2;
            const otrcodeY = textY - 0.1;
            const otrtextAbove =
              myaccountlable.OTR_NUMBER +
              " : " +
              applicationDetails?.oneTimeRegistrationNo;
            pdf.setFontSize(7);
            pdf.text(
              otrtextAbove,
              otrcodeX + otrcodeWidth / 2,
              otrcodeY - 0.01,
              { align: "center" }
            );

            const barcodeWidth = 1.5;
            const barcodeHeight = 0.4;
            const barcodeX = textX - barcodeWidth - 0.2;
            const barcodeY = textY - 0.15;
            const textAbove =
              applicationDetails.application &&
              applicationDetails.application.applicationNo;
            pdf.setFontSize(7);
            pdf.text(textAbove, barcodeX + barcodeWidth / 2, barcodeY - 0.01, {
              align: "center",
            });
            pdf.addImage(
              barcodeDataUrl,
              "SVG",
              barcodeX,
              barcodeY,
              barcodeWidth,
              barcodeHeight
            );
            const textBelow =
              applicationDetails &&
                applicationDetails.application &&
                applicationDetails.application.createdAt
                ? dayjs(applicationDetails.application.createdAt).format(
                  common.COMMON.CURRENT_DATE_TIME_FORMAT
                )
                : "";
            pdf.setFontSize(7);
            pdf.text(
              textBelow,
              barcodeX + barcodeWidth / 2,
              barcodeY + barcodeHeight + 0.01,
              { align: "center" }
            );
            pdf.setFontSize(7);
            pdf.text(`${i}`, textX, textY);
          }
          pdf.save(`${filename}.pdf`);
        };
      });
  };

  const candidateProfileUnlockAction = (profileId) => {
    let requestBody = {};
    if (props.isTab == 1) {
      requestBody.eligibilityType = "check_Eligibility";
    } else if (props.isTab == 2) {
      requestBody.eligibilityType = "re_Check_Eligibility";
    } else if (props.isTab == 3) {
      requestBody.eligibilityType = "application_download";
    } else if (props.isTab == 4) {
      requestBody.eligibilityType = "profile_download";
    }
    if (seachType == "email") {
      requestBody.value = emailId;
    }
    if (seachType == "mobile") {
      requestBody.value = mobileNumber;
    }
    if (seachType == "aadhaar") {
      requestBody.value = aadhaarNumber;
    }
    if (seachType == "applicationNo") {
      requestBody.value = applicationNo;
    }
    if (seachType == "otrNumber") {
      requestBody.value = otrNumber;
    }
    requestBody.type = seachType;
    requestBody.advertisementId = advtIdForSearch;
    // dispatch(searchCandidateListForCheckEligibility(requestBody))
    profileId &&
      dispatch(
        candidateProfileUnlock(
          profileId,
          searchCandidateListForCheckEligibility,
          requestBody
        )
      );
  };

  let { enableEditProfileWithLock } = useSelector(
    (state) => state.common,
    shallowEqual
  );

  const advertisementOptions = activeAdvertisementList.map((ele) => ({
    value: ele.id,
    label: `${ele.advertisementNo}/${ele.year}-${ele.name}`,
  }));

  const selectedAdvertisement =
    advertisementOptions.find((option) => option.value === advtIdForSearch) ||
    null;

  return showActiveTabCandidateDetails ? (
    <ActiveCandidateDetailsTab advt={advtIdForSearch} isTab={props.isTab} />
  ) : (
    <div className="d-flex justify-content-center">
      <main
        role="main"
        className="col-sm-9 col-md-11 col-lg-12 "
        id="main_block"
      >
        <div className="box-one mt-2 p-4">
          <form id="searchForm">
            <div className="row ms-2">
              {props.isTab != 4 && (
                <div className="col-md-2">
                  <label className="fw-bold  float-start">
                    {docLabels.SELECT_YEAR}
                  </label>
                  <select
                    className="form-select"
                    name="selectedYear"
                    value={startYear}
                    onChange={(e) => {
                      handleYearChange(e.target.value);
                    }}
                  >
                    {yearList &&
                      yearList.length > 0 &&
                      yearList.map((element, i) => (
                        <option key={i}>{element}</option>
                      ))}
                  </select>
                </div>
              )}
              {props.isTab != 4 && (
                <div className="col-md-6">
                  <label className="fw-bold ">
                    {label.SELECT_ADVT}&nbsp;
                    <span className="redColor">*</span>
                  </label>
                  {/* <select className="form-select" name="search_using" value={advtIdForSearch} onChange={(e) => handleDropdownSeachAdvt(e)}>
                                            <option key="" value="">{commonLabels.COMBO_SELECT}</option>
                                            {activeAdvertisementList.map((ele, i) => <option key={i} value={ele.id}>{ele.advertisementNo}{"/"}{ele.year}-{ele.name}</option>)}
                                        </select> */}

                  <Select
                    // className="form-select mt-1"
                    name="search_using"
                    options={advertisementOptions}
                    value={selectedAdvertisement}
                    onChange={(selectedOption) => {
                      handleDropdownSeachAdvt({
                        target: {
                          name: "search_using",
                          value: selectedOption?.value || "",
                        },
                      });
                    }}
                    placeholder={commonLabels.COMBO_SELECT}
                    isClearable
                  />

                  <div></div>
                </div>
              )}

              <div className="col-md-2">
                <label className="fw-bold ">
                  {label.SEARCH_USING}&nbsp;
                  <span className="redColor">*</span>
                </label>
                {props.isTab == "3" ? (
                  <select
                    className="form-select"
                    name="searchType"
                    value={seachType}
                    onChange={(e) => handleDropdownSeachType(e)}
                  >
                    <option key="" value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {label.DOWNLOAD_PROFILE_DROPDOWN.map((ele, i) => (
                      <option key={i} value={ele.value}>
                        {ele.label}
                      </option>
                    ))}
                  </select>
                ) : props.isTab == "4" ? (
                  <select
                    className="form-select"
                    name="searchType"
                    value={seachType}
                    onChange={(e) => handleDropdownSeachType(e)}
                  >
                    <option key="" value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {label.CANDIDATE_PROFILE_DROPDOWN.map((ele, i) => (
                      <option key={i} value={ele.value}>
                        {ele.label}
                      </option>
                    ))}
                  </select>
                ) : (
                  <select
                    className="form-select"
                    name="searchType"
                    value={seachType}
                    onChange={(e) => handleDropdownSeachType(e)}
                  >
                    <option key="" value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {label.DROPDOWN_USING.map((ele, i) => (
                      <option key={i} value={ele.value}>
                        {ele.label}
                      </option>
                    ))}
                  </select>
                )}
              </div>

              <div className="col-md-2 pad_Left_Right_0">
                {seachType === "email" ? (
                  <div className="form-group">
                    <label className="fw-bold ">
                      {" "}
                      {label.SEARCH_VALUE}&nbsp;
                      <span className="redColor">*</span>
                    </label>
                    <input
                      name="emailId"
                      id="emailId"
                      ref={register({ required: true, pattern: emailRegex })}
                      className="form-control"
                      onChange={(e) =>
                        handleValueParam("emailId", e.target.value)
                      }
                      type="text"
                    />
                    {_.get("emailId.type", errors) === "required" && (
                      <p className="errorText">
                        {label.SEARCH_VALUE_IS_REQUIRED}
                      </p>
                    )}
                    {_.get("emailId.type", errors) === "pattern" && (
                      <p className="errorText">{label.ENTER_VALID_EMAIL_ID}</p>
                    )}
                  </div>
                ) : null}
                {seachType === "mobile" ? (
                  <div className="form-group">
                    <label className="fw-bold ">
                      {" "}
                      {label.SEARCH_VALUE}&nbsp;
                      <span className="errorText">*</span>
                    </label>

                    <input
                      name="mobileNumber"
                      id="mobileNumber"
                      maxLength={10}
                      ref={register({ required: true, pattern: mobileRegex })}
                      className="form-control"
                      onChange={(e) =>
                        handleValueParam("mobileNumber", e.target.value)
                      }
                      type="text"
                    />

                    {_.get("mobileNumber.type", errors) === "required" && (
                      <p className="errorText">
                        {label.SEARCH_VALUE_IS_REQUIRED}
                      </p>
                    )}
                    {_.get("mobileNumber.type", errors) === "pattern" && (
                      <p className="errorText">
                        {label.ENTER_VALID_MOBILE_NUMBER}
                      </p>
                    )}
                  </div>
                ) : null}
                {seachType === "aadhaar" ? (
                  <div className="form-group">
                    <label className="fw-bold ">
                      {" "}
                      {label.SEARCH_VALUE}&nbsp;
                      <span className="redColor">*</span>
                    </label>
                    <input
                      name="aadhaarNumber"
                      id="aadhaarNumber"
                      ref={register({ required: true, pattern: aadhaarNumber })}
                      className="form-control"
                      onChange={(e) =>
                        handleValueParam("aadhaarNumber", e.target.value)
                      }
                      type="number"
                    />
                    {_.get("aadhaarNumber.type", errors) === "required" && (
                      <p className="errorText">
                        {label.SEARCH_VALUE_IS_REQUIRED}
                      </p>
                    )}
                    {_.get("aadhaarNumber.type", errors) === "pattern" && (
                      <p className="errorText">
                        {label.ENTER_VALID_AADHAAR_NUMBER}
                      </p>
                    )}
                  </div>
                ) : null}
                {seachType === "applicationNo" ? (
                  <div className="form-group">
                    <label className="fw-bold ">
                      {" "}
                      {label.SEARCH_VALUE}&nbsp;
                      <span className="errorText">*</span>
                    </label>

                    <input
                      name="applicationNo"
                      id="applicationNo"
                      ref={register({
                        required: true,
                        pattern: numberValidation,
                      })}
                      className="form-control"
                      onChange={(e) =>
                        handleValueParam("applicationNo", e.target.value)
                      }
                      type="text"
                    />

                    {_.get("applicationNo.type", errors) === "required" && (
                      <p className="errorText">
                        {label.SEARCH_VALUE_IS_REQUIRED}
                      </p>
                    )}
                    {_.get("applicationNo.type", errors) === "pattern" && (
                      <p className="errorText">{label.ONLY_NUMBERS_ALLOWED}</p>
                    )}
                  </div>
                ) : null}

                {seachType === "otrNumber" ? (
                  <div className="form-group">
                    <label className="fw-bold ">
                      {" "}
                      {label.SEARCH_VALUE}&nbsp;
                      <span className="errorText">*</span>
                    </label>

                    <input
                      name="otrNumber"
                      id="otrNumber"
                      ref={register({
                        required: true,
                        pattern: alphanumeric,
                      })}
                      className="form-control"
                      onChange={(e) =>
                        handleValueParam("otrNumber", e.target.value)
                      }
                      type="text"
                    />

                    {_.get("otrNumber.type", errors) === "required" && (
                      <p className="errorText">
                        {label.SEARCH_VALUE_IS_REQUIRED}
                      </p>
                    )}
                    {_.get("otrNumber.type", errors) === "pattern" && (
                      <p className="errorText">{label.ONLY_ALPHA_NUMBERS_ALLOWED}</p>
                    )}
                  </div>
                ) : null}
                {seachType != "aadhaar" &&
                  seachType != "mobile" &&
                  seachType != "email" &&
                  seachType != "applicationNo" &&
                   seachType != "otrNumber" ? (
                  <div className="form-group">
                    <label className="fw-bold ">
                      {" "}
                      {label.SEARCH_VALUE}&nbsp;
                      <span className="redColor">*</span>
                    </label>
                    <input
                      disabled={true}
                      name="disabled"
                      id="disabled"
                      className="form-control"
                      type="text"
                    />
                  </div>
                ) : null}
              </div>
            </div>
            <div className="col-md-12 d-flex justify-content-end">
              <button
                type="button"
                disabled={
                  props.isTab != 4
                    ? !(
                      formState.isValid &&
                      seachType &&
                      advtIdForSearch &&
                      (emailId ||
                        mobileNumber ||
                        aadhaarNumber ||
                        applicationNo ||
                         otrNumber)
                    )
                    : !(
                      formState.isValid &&
                      seachType &&
                      (emailId || mobileNumber)
                    )
                }
                className="btn btn-primary custom_button btn-sm"
                onClick={() => searchAction()}
              >
                {label.SEARCH}
              </button>
              &nbsp;&nbsp;
              <button
                type="button"
                onClick={resetAction}
                className="btn btn-outline-secondary btn-sm closeCustom_button"
              >
                {label.RESET}
              </button>
            </div>
          </form>
        </div>

        {candidateList && candidateList.length > 0 ? (
          <div className="box-one">
            <div className="border border-light text-center w-100 p-3">
              <table className="table table-bordered">
                <thead className="table-primary">
                  {props.isTab == "3" ? (
                    <tr>
                      {label.downloadDocumentTableheader.map((ele, i) => (
                        <th scope="col" key={i} className="table-primary">
                          {ele}
                        </th>
                      ))}
                    </tr>
                  ) : (
                    <tr>
                      {label.tableheader.map((ele, i) => (
                        <th scope="col" key={i} className="table-primary">
                          {ele}
                        </th>
                      ))}
                    </tr>
                  )}
                </thead>

                <tbody>
                  {candidateList &&
                    candidateList.map((ele, i) => {
                      if (ele) {
                        return (
                          <tr key={i}>
                            {props.isTab == "3" ? (
                              <td>
                                {ele && ele.applicationNo && ele.applicationNo}
                              </td>
                            ) : (
                              <td>
                                {ele &&
                                  ele.personalInfoList &&
                                  ele.personalInfoList.aadhaarNo
                                  ? ele.personalInfoList.aadhaarNo
                                  : "-"}
                              </td>
                            )}
                            <td>
                              {ele &&
                                ele.personalInfoList &&
                                ele.personalInfoList.englishFullName}
                            </td>
                            <td>
                              {ele &&
                                ele.personalInfoList &&
                                ele.personalInfoList.firstName}
                            </td>
                            <td>
                              {ele &&
                                ele.personalInfoList &&
                                ele.personalInfoList.middleName}
                            </td>
                            <td>
                              {ele &&
                                ele.personalInfoList &&
                                ele.personalInfoList.surname}
                            </td>
                            <td>
                              {ele &&
                                ele.personalInfoList &&
                                ele.personalInfoList.mobileNumber}
                            </td>
                            <td>
                              {ele &&
                                ele.personalInfoList &&
                                ele.personalInfoList.emailId}
                            </td>
                            <td>
                              <button
                                className="btn btn-outline-primary  custom_button  btn-sm cursor-pointer"
                                type="button"
                                onClick={(e) => {
                                  viewCandidateDetails(ele);
                                }}
                              >
                                {label.VIEW}
                              </button>
                           
                              {ele?.isLocked === true && (
                                <>
                                  {props.isTab == "4" ? (
                                    <button
                                      className="btn btn-outline-primary custom_button btn-sm cursor-pointer ms-2"
                                      type="button"
                                      onClick={() =>
                                        candidateProfileUnlockAction(
                                          ele?.personalInfoList?.profileId
                                        )
                                      }
                                    >
                                      {label.UNLOCK_PROFILE}
                                    </button>
                                  ) : (
                                    ""
                                  )}
                                </>
                              )}
                              
                              {props.isTab == "3" && (
                                <>
                                  { ele?.paymentStatus == true ? (
                                    <button
                                      className="btn btn-outline-primary custom_button btn-sm cursor-pointer ms-2"
                                      type="button"
                                      onClick={() =>
                                        dispatch(printPaymentReceipt(
                                          ele?.applicationId
                                        ))
                                      }
                                    >
                                      {label.PRINT_RECEIPT}
                                    </button>
                                  ) : (
                                    ""
                                  )}
                                </>
                              )}
                            </td>
                          </tr>
                        );
                      }
                    })}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div>
            <p className="text-center">{label.NO_DATA_TO_DISPLAY}</p>
          </div>
        )}

        <Modal
          size="xl"
          show={printProfile}
          onHide={() => {
            setPrintProfile(false);
          }}
          backdrop="static"
        >
          <Modal.Header
            className="logout_heading"
          >
            {props.isTab == "4" && (
              <h4>
                {label.CANDIDATE_PROFILE}
              </h4>
            )}
            {props.isTab == "3" && (
              <h4>
                {label.APPLICATION_PROFILE}
              </h4>
            )}

            <button
              type="button"
              className="ms-auto logout_close"
              aria-label="Close"
              onClick={() => {
                setPrintProfile(false);
              }}
            >X</button>
          </Modal.Header>
          <Modal.Body>
            <div className="container" ref={printRef}>
              {props.isTab == 4 ? (
                <div>
                  <PrintProfileDetails
                    applicationDetails={applicationDetails}
                    applicationData={currentApplicationData}
                    applicationPostData={
                      applicationDetails &&
                      applicationDetails.applicationPostPrefDtoList &&
                      applicationDetails.applicationPostPrefDtoList.filter(
                        (e) => e.preferredAppointingAuthorities
                      )
                    }
                    isPrintBtn="true"
                    isPrinting={isPrinting}
                    setIsPrinting={setIsPrinting}
                    isAdminSide={isAdminSide}
                    profileId={candidateProfileId}
                  />
                </div>
              ) : (
                ""
              )}
              {props.isTab == 3 ? (
                <div>
                  <PrintApplicationDetails
                    applicationDetails={applicationDetails}
                    applicationPostData={
                      applicationDetails &&
                      applicationDetails.applicationPostPrefDtoList &&
                      applicationDetails.applicationPostPrefDtoList.filter(
                        (e) => e.preferredAppointingAuthorities
                      )
                    }
                    isPrintBtn="true"
                    isPrinting={isPrinting}
                    setIsPrinting={setIsPrinting}
                    isAdminSide={isAdminSide}
                    profileId={candidateProfileId}
                  />
                </div>
              ) : (
                ""
              )}
              {/* <button type="button" className=" btn btn-primary custom_button  printBtnCss" onClick={handlePrint} >{label.PRINT}</button> */}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-secondary closeCustom_button"
              onClick={() => {
                setPrintProfile(false);
              }}
            >
              {challanLabels.CANCEL}
            </button>
          </Modal.Footer>
        </Modal>
      </main>
    </div>
  );
};
export default CandidateDataManagement;
